module.exports = __webpack_public_path__ + "static/media/rotate-b2.3.86cc2a4b.svg";